<div class="container-style py-2">
  <app-custom-table [showRecover]="true" [showExport]="true" [headers]="header" [data]="data" [actions]="tableActions"
    [previousFilters]="filters" [filterPersistentKey]="url" (onPageChange)="onPageChange($event)"
    (onRecoverData)="getAllConceptInvoicingsForAccountingModelWithPagination()" (onExport)="onExport()"
    (onFilterChange)="onFilterChange($event)" (onAction)="onAction($event)">
  </app-custom-table>
</div>
<app-custom-modal #conceptInvoicingForAccountingModelModal [label]="'Captura Concepto de Facturación'"
  [header]="'Captura Concepto de Facturación'" [children]="componentRegisterConceptInvoicing"
  [inputs$]="inputsForConceptInvoicing$" [output$]="inputsForConceptInvoicing$" [width]="'50rem'" hidden>
</app-custom-modal>